<template>
  <el-dialog
    :title="isUpdate ? '编辑银行' : '添加银行'"
    :visible="visible"
    width="560px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    append-to-body
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="国家名称:" prop="country_id">
        <el-select
          v-model="form.country_id"
          clearable
          filterable
          placeholder="请选择"
          class="ele-fluid"
          :loading="countryLoading">
          <el-option
            v-for="item in countryList"
            :key="item.id"
            :label="item.name"
            :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="银行名称:" prop="bank_name">
        <el-input v-model="form.bank_name" clearable placeholder="请输入" maxlength="50" />
      </el-form-item>
      <el-form-item label="银行编码:" prop="bank_code">
        <el-input v-model="form.bank_code" clearable placeholder="请输入" maxlength="50" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
const defaultForm = () => ({
  country_id: '',
  bank_name: '',
  bank_code: ''
});

export default {
  name: 'BanksEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        country_id: [{ required: true, message: '请选择', trigger: 'change' }],
        bank_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        bank_code: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      countryList: [],
      countryLoading: false,
      loading: false,
      isUpdate: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
        this.queryCountryList();
      }
    },
    data() {
      if (this.visible) {
        this.initForm();
      }
    }
  },
  methods: {
    queryCountryList() {
      if (this.countryList.length) {
        return;
      }
      this.countryLoading = true;
      this.$http.get('/CountryRegion/getCountryRegionList').then((res) => {
        this.countryLoading = false;
        if (res.data.code === 0) {
          this.countryList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.countryLoading = false;
        this.$message.error(e.message);
      });
    },
    initForm() {
      if (this.data && Object.keys(this.data).length) {
        this.form = Object.assign(defaultForm(), {
          id: this.data.id,
          country_id: this.data.country_id,
          bank_name: this.data.bank_name,
          bank_code: this.data.bank_code
        });
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/ChinaBanks/edit', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '保存成功');
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
